import { DETAIL_ANIMAL_SEARCH_TYPES } from '@/constants/searchType';
import type { SearchType } from '@/hooks/publicSearch/useSearchType';
import { PAGE_SIZE_OPTIONS } from '@/components/publicSearch/constants';

export const ALL_SALE_LOTS_PAGE_SIZE = -1;
export const SALE_LOT_PAGE_SIZE_OPTIONS = [
  ...PAGE_SIZE_OPTIONS,
  { value: ALL_SALE_LOTS_PAGE_SIZE, label: 'ALL' },
];
export const SALE_LOT_GALLERY_PAGE_SIZE_OPTIONS = [
  10,
  25,
  50,
  { value: ALL_SALE_LOTS_PAGE_SIZE, label: 'ALL' },
];

const DEFAULT_PAGINATION = { page: 0, pageSize: 50 };

// The grid store is shared across public searches. ALL belongs only to the
// lots within a sale; never send its sentinel to animal/member/sale searches.
export function getSearchPagination(
  model: { page: number; pageSize: number },
  searchType: SearchType,
) {
  return model.pageSize === ALL_SALE_LOTS_PAGE_SIZE &&
    !DETAIL_ANIMAL_SEARCH_TYPES.includes(searchType)
    ? DEFAULT_PAGINATION
    : model;
}
